import type {
  TriggerEvaluationResponse,
  TriggerEvaluationViewModel,
  EvaluationSummaryResponse,
  EvaluationSummaryViewModel,
  EvaluationListResponse,
  EvaluationListViewModel,
  DifferenceResponse,
  DifferenceViewModel,
  EvaluationDetailResponse,
  EvaluationDetailViewModel,
} from "@models/evaluation";

export const buildTriggerEvaluationViewModel = (
  response: TriggerEvaluationResponse,
): TriggerEvaluationViewModel => {
  return {
    processId: response.process_id,
    message: response.message,
  };
};

export const buildEvaluationSummaryViewModel = (
  response: EvaluationSummaryResponse,
): EvaluationSummaryViewModel => {
  return {
    processId: response.process_id,
    fileCount: response.file_count,
    avgAccuracy: response.avg_accuracy,
    avgDuration: response.avg_duration,
    createdAt: new Date(response.created_at),
  };
};

export const buildEvaluationListViewModel = (
  response: EvaluationListResponse,
): EvaluationListViewModel => {
  return {
    items: response.items.map(buildEvaluationSummaryViewModel),
    total: response.total,
    limit: response.limit,
    lastEvaluatedKey: response.last_evaluated_key,
  };
};

export const buildDifferenceViewModel = (
  response: DifferenceResponse,
): DifferenceViewModel => {
  return {
    field: response.field,
    expected: response.expected,
    actual: response.actual,
    diffType: response.diff_type,
  };
};

export const buildEvaluationDetailsViewModel = (
  responses: EvaluationDetailResponse[],
): EvaluationDetailViewModel[] => {
  return responses.map(buildEvaluationDetailViewModel);
};

export const buildEvaluationDetailViewModel = (
  response: EvaluationDetailResponse,
): EvaluationDetailViewModel => {
  return {
    id: response.id,
    processId: response.process_id,
    processItemId: response.process_item_id,
    fileName: response.file_name,
    doctype: response.doctype,
    flowBaseId: response.flow_base_id,
    flowVersion: response.flow_version,
    duration: response.duration,
    accuracy: response.accuracy,
    precision: response.precision,
    recall: response.recall,
    f1Score: response.f1_score,
    truePositives: response.tp,
    falsePositives: response.fp,
    falseNegatives: response.fn,
    differences: response.differences
      ? response.differences.map(buildDifferenceViewModel)
      : [],
    createdAt: new Date(response.created_at),
  };
};
